const defaultState = {
  currentUser: {
    __typename: 'currentUser',
    isAuthenticated: false,
    id: 'notloggedin',
    username: `Guest`,
    email: 'guest@gmail.com',
    cognitoUserId: `Guest-${Date.now()}`,
    avatar: false,
    role: null,
    defaultRole: null,
    roles: [],
    features: [],
    notifications: [],
    isAdmin: false,
    isPreviewOrg: false,
    permission: null,
    ssoToken: null,
    campaignTableDisplayColumns: [],
    timezone: null,
  },
};

export default defaultState;
